export default "__VITE_ASSET__eQuWpn38__"